import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout-Route fuer /rechnungen. Reine Wrapper-Komponente — Listen-Inhalt liegt in
 * rechnungen.index.tsx, Detail-/Form-Routen (rechnungen.$id.tsx, rechnungen.neu.tsx) werden ueber
 * den Outlet hier gerendert.
 *
 * Vorher hatte rechnungen.tsx selbst die Listen-Komponente — TanStack file-based
 * Routing hat sie aber als Parent fuer die Child-Routen erkannt. Ohne Outlet
 * sind Children nie gerendert; Klick auf "/rechnungen/neu" zeigte still die Liste.
 */
export const Route = createFileRoute('/rechnungen')({
  component: RechnungenLayout,
});

function RechnungenLayout() {
  return <Outlet />;
}
